import React from "react";

import { DialogActions } from "@material-ui/core";

import Left from "./Left";
import Right from "./Right";

type Props = {
  children: React.ReactNode;
};

export default function Actions({ children }: Props) {
  let content = React.Children.toArray(children);

  if (
    content.length &&
    React.isValidElement(content[0]) &&
    content[0].type !== Left &&
    content[0].type !== Right
  ) {
    return (
      <DialogActions>
        <Right>{content}</Right>
      </DialogActions>
    );
  }

  return <DialogActions>{content}</DialogActions>;
}

Actions.Left = Left;
Actions.Right = Right;
